/**
 * (c) copyright 2012-2022 mgm technology partners GmbH.
 * This software, the underlying source code and other artifacts are protected by copyright.
 * All rights, in particular the right to use, reproduce, publish and edit are reserved.
 * A simple right of use (license) can be acquired for use, duplication, publication, editing etc..
 * Requests for this can be made at A12-license@mgm-tp.com or other official channels of the copyright holder.
 */
/**
 * @packageDocumentation
 * @module models
 */
import { ModelPath } from "@com.mgmtp.a12.base/base-model-api/lib/main/model";

export namespace FormModelPath {
	/**
	 * Extends the given form model path of the parent element with the respective representation of the given form model
	 * elements.
	 */
	export function extend(parentFormModelPath: ModelPath, ...formModelElement: readonly object[]): ModelPath {
		const formModelElementPaths = formModelElement.map(e => ({
			elementName: getModelPathElementName(e)
		}));
		return [...parentFormModelPath, ...formModelElementPaths];
	}
}

/** @internal */
export function getModelPathElementName(formModelElement: { readonly name?: string; readonly id?: string }): string {
	const elementName = formModelElement.name ?? formModelElement.id;

	if (elementName === undefined) {
		throw new Error(
			`unexpected form model element without id and name encountered.
			${formModelElement}`
		);
	}

	return elementName;
}
